<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content stories">
                    <h2 class="crossline-title text-center">Featured Stories</h2>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Butch Otter</h3>
                            <h4>Governor of Idaho</h4>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-1.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                I was born in Caldwell and it will always be home to me. As a proud College of Idaho graduate, I’m excited about the great things that are happening in downtown Caldwell. Miss Lori and I are thrilled to support this effort, and we hope that you will too.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Mayor Garret Nancolas</h3>
                            <h4>City of Caldwell</h4>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-2.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Caldwell is my home, it is my family's home...We love Caldwell!!  I have such fond memories of downtown Caldwell from my childhood!  This beautiful plaza, along with the Indian Creek restoration, will be the catalyst for returning Downtown Caldwell to its proper place as the heartbeat of our great City!!  The family atmosphere and wholesome activities will create wonderful family memories for generations to come!!  This will be a part of Caldwell's Legacy as the Treasure of the Valley!!!!
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Bob Jenkins</h3>
                            <h4>Valli Information Systems</h4>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-3.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                Caldwell is my home town!  I remember Caldwell when downtown was thriving with shopping, dining and entertainment that attracted residents from the entire Treasure Valley to our community. The positive energy of downtown Caldwell was replaced by vacant buildings, empty streets and little attractions.  Our family is involved in revitalizing downtown because we believe in this Caldwell!  Indian Creek Plaza will bring life back into our downtown by creating a gathering place we can all be proud of...a place where families can create lasting memories and economic opportunities for small businesses will be plentiful.  We love our home town!
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <h3>Dr. Bob Hoover</h3>
                            <h4>Interim President of The College of Idaho</h4>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-4.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                In returning to Caldwell and The College of Idaho, I discovered one clear difference since I left in 2009—the excitement of downtown Caldwell with the Indian Creek Plaza and all the changes associated downtown with that project.  I am so impressed with what this will mean for all of us living here now and in the future.  I and The College of Idaho are pleased to be associated with this marvelous project.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Betsy Hunsicker</h3>
                            <h4>CEO West Valley Medical Center</h4>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-5.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                We are fairly new to Caldwell, so we aren’t part of the rich history of this community; however, we are so excited to be part of the next chapter in Caldwell’s history and to contribute in this small way to our city’s future.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <h3>Keri Smith-Sigman</h3>
                            <h4>Co-Founder Destination Caldwell</h4>
                            <div class="img-box">
                                <div class="img-wrap">
                                    <img src="images/story-6.png" alt="">
                                </div>
                            </div>
                            <p class="text-left">
                                C-Town" is my home! It’s where we have built memories riding bikes from rural Canyon County into downtown to buy a mile-high milkshake.  And oh so many firsts, but my favorites: first day with my sweet husband, the birth town for my babies, and it’s where I rode my first horse.  I cannot wait for the day when I get to watch my family have a “first experience” in Indian Creek Plaza.  The memories will be countless.  We are so thankful to be a part of the community that has united to build Indian Creek Plaza!  Cheers to Caldwell’s future!
                            </p>
                        </div>
                    </div>
                    <share-story hr="above"></share-story>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import ShareStory from '@/components/ShareStory.vue';
    export default {
        name: 'stories',
        components: {
            'share-story': ShareStory
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Stories.vue?63db6771